__turbopack_context__.v({
  "suggestion": "SearchSuggestions-module-scss-module__5dVlGG__suggestion",
});
